const menuDefault = [
  // {
  //   icon: "GlobeIcon",
  //   pageName: "landing-page",
  //   title: "หน้าหลัก",
  // },
  /*
  {
    icon: "HomeIcon",
    pageName: "side-menu-dashboard",
    title: "รายงาน",
    subMenu: [
      {
        icon: "",
        pageName: "side-menu-dashboard-overview-1",
        title: "Dashboard 1",
      },
      {
        icon: "",
        pageName: "side-menu-dashboard-overview-2",
        title: "Dashboard 2",
      },
    ],
  },
  */
  {
    icon: "PieChartIcon",
    pageName: "dashboards-overview-1",
    title: "Dashboard",
    routeName: "dashboard-overview",
  },
  {
    icon: "HomeIcon",
    pageName: "main-house-hold",
    title: "ครัวเรือน",
    routeName: "household"
  },
  // {
  //   icon: "UsersIcon",
  //   pageName: "family-page",
  //   title: "ครอบครัว",
  // },
  {
    icon: "UsersIcon",
    pageName: "member-page",
    title: "สมาชิก",
    routeName: "member"
  },
  {
    icon: "NeetsIcon",
    pageName: "neets",
    title: "เด็ก NEETs",
    routeName: "neets"
  },
  {
    icon: "DisabilityIcon",
    pageName: "cwd",
    title: "เด็กพิการ",
    routeName: "cwd"
  },
  // {
  //   key: "devider",
  //   isAdmin: true
  // },
  {
    icon: "FormIcon",
    title: "แบบสอบถาม",
    routeName: "survey-management-menu",
    subMenu: [
      {
        icon: "FormIcon",
        pageName: "survey-datatable",
        title: "จัดการแบบสอบถาม",
        routeName: "survey-datatable"
      },
      {
        icon: "FormIcon",
        pageName: "house-survey-management",
        title: "ครัวเรือน",
        routeName: "household"
      },
      {
        icon: "FormIcon",
        pageName: "member-survey-management",
        title: "สมาชิก",
        routeName: "member"
      },
      {
        icon: "FormIcon",
        pageName: "neets-survey-management",
        title: "เด็ก NEETs",
        routeName: "neets"
      },
      {
        icon: "FormIcon",
        pageName: "cwd-survey-management",
        title: "เด็กพิการ",
        routeName: "cwd"
      },
    ],
  },
  {
    icon: "GiftIcon",
    title: "สวัสดิการ",
    routeName: "welfare-management-menu",
    subMenu: [
      {
        icon: "GiftIcon",
        pageName: "welfare-rules",
        title: "1. คำถาม → ปัญหา 5 มิติ",
        routeName: "welfare-rules"
      },
      {
        icon: "GiftIcon",
        pageName: "welfare-mapping",
        title: "2. ปัญหา → สวัสดิการ",
        routeName: "welfare-mapping"
      },
      {
        icon: "GiftIcon",
        pageName: "welfare-catalog",
        title: "รายการสวัสดิการ",
        routeName: "welfare-catalog"
      },
      {
        icon: "GiftIcon",
        pageName: "welfare-settings",
        title: "ตั้งค่าและประวัติ",
        routeName: "welfare-settings"
      },
    ],
  },
  {
    icon: "LayoutIcon",
    pageName: "permission-management",
    title: "จัดการสิทธิ์",
    routeName: "permission-management",
  }
]

const state = () => {
  return {
    menu: [...menuDefault]
  };
};

// getters
const getters = {
  menu: (state, getters, rootState, rootGetters) => {
    return state.menu.filter(x=> {
      if(rootGetters["network/isOnline"])
        return x.permission || x?.subMenu?.some(s=> s.permission)
      return x.routeName != "survey-management-menu" && x.routeName != "welfare-management-menu" && x.routeName != "permission-management" && x.routeName != "dashboard-overview"
    })
  }
};

// actions
const actions = {
  setPermissionToMenu({commit}, data){
    commit("setPermissionToMenu", data)
  }
};

// mutations
const mutations = {
  setPermissionToMenu(state, data){
    let currentMenuDefault = JSON.parse(JSON.stringify(menuDefault))
    let newMenu = data.menu.filter(item=> item.code_name != "CWD" && item.code_name != "NEET" && item.code_name != "IN" && item.code_name != "HH")
    let checkIsAdmin = data.route.some(route => route.name == "survey-management")
    let surveyMenuIdx = currentMenuDefault.findIndex(item=> item.routeName == "survey-management-menu")
    let activeMenuLastIdx = 4
    for(let menu of newMenu){
      if(checkIsAdmin){
        let checkAdminIdx = currentMenuDefault[surveyMenuIdx].subMenu.findIndex(item=> item.routeName == menu.name_en)
        if(checkAdminIdx == -1){
          currentMenuDefault[surveyMenuIdx].subMenu.push(
            {
              icon: "FormIcon",
              pageName: "survey-management",
              params: {survey: menu.name_en},
              title: menu.short_name,
              routeName: menu.name_en,
              path: `/admin/${menu.name_en}`
            }
          )
        }
      }
      else{
        activeMenuLastIdx++
        currentMenuDefault.splice(activeMenuLastIdx, 0, {
          icon: "FormIcon",
          pageName: "publish-survey",
          params: {survey: menu.name_en},
          title: menu.short_name,
          routeName: "publish-survey",
          path: `/survey/${menu.name_en}`
        })
      }
    }
    let temp = currentMenuDefault.map(x=>{
      if(x.routeName == "survey-management-menu"){
        if(data.route.some(r => r.name == "house-survey-management")){
          x.permission = true
        }
      }
      else if(x.subMenu){
        x.subMenu = x.subMenu.filter(s=>{
          if(data.route.some(r => r.name == s.pageName)){
            s.permission = true
          }
          return s.permission
        })
      }
      else{
        const checkAllowRoute = x.params?.survey ? data.route.some(r=> r.name == x.pageName && r.params.survey == x.params.survey) : data.route.some(r=> r.name == x.pageName)
        if(checkAllowRoute)
          x.permission = true
      }
      if((data.route.some(r=> r.name == "permission-management") || data.route.some(r=> r.name == "house-survey-management")) && x.key == "devider")
        x.permission = true
      return x
    })

    state.menu = temp
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
